enum FacilitatorMetricType {
  Groups = 'GROUPS',
  Members = 'MEMBERS',
  Attendance = 'ATTENDANCE_RATE',
  AverageMembers = 'AVERAGE_MEMBERS',
  AverageSavings = 'AVERAGE_SAVINGS',
}

export default FacilitatorMetricType;
